import React from 'react';
import { AppBar, Toolbar, Button, Box, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../app/contexts/AuthContext';
import { ReactComponent as Logo } from '../../app/assets/tivra_logo.svg';

export default function Header() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleAuthAction = async () => {
    if (user) {
      try {
        await logout();
        navigate('/');
      } catch (error) {
        console.error('Error logging out:', error);
      }
    } else {
      navigate('/signup');
    }
  };

  const handleLogoClick = () => {
    navigate('/');
  };

  const handleGoToApp = () => {
    navigate('/app/meetings');
  };

  return (
    <AppBar 
      position="static" 
      color="transparent" 
      elevation={0}
      sx={{ 
        borderBottom: '1px solid',
        borderColor: 'divider'
      }}
    >
      <Container maxWidth="lg" disableGutters>
        <Toolbar 
          sx={{ 
            justifyContent: 'space-between',
            py: '1.5rem',
            px: '0px'
          }}
        >
          <Box 
            onClick={handleLogoClick}
            sx={{ 
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Logo style={{ height: '64px'}} />
          </Box>
          <Box>
            {user ? (
              <>
                <Button 
                  color="primary"
                  onClick={handleGoToApp}
                  sx={{ 
                    mr: 2,
                    textTransform: 'none'
                  }}
                >
                  Go to app
                </Button>
                <Button
                  variant="outlined"
                  onClick={handleAuthAction}
                  sx={{ 
                    textTransform: 'none',
                    borderRadius: '20px'
                  }}
                >
                  Sign out
                </Button>
              </>
            ) : (
              <Button
                variant="contained"
                onClick={handleAuthAction}
                sx={{ 
                  textTransform: 'none',
                  borderRadius: '20px',
                  backgroundColor: '#3366FF',
                  '&:hover': {
                    backgroundColor: '#2952CC'
                  }
                }}
              >
                Sign up here
              </Button>
            )}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
} 